import { createSlice } from '@reduxjs/toolkit';

// On-screen keyboard preferences. In-memory only (per session), in line with the
// app's traceless model — `wipeOutTraces` clears storage anyway, and the layout is
// re-suggested from the browser each session. `layoutId` stays null until the first
// time the keyboard opens, then it's resolved via suggestLayout.
const initialState = {
  layoutId: null,
  shuffle: false, // desktop high-security: randomized layout so physical key positions diverge from the OS
  recent: [],
};

const keyboardSlice = createSlice({
  name: 'keyboard',
  initialState,
  reducers: {
    setLayout: (state, action) => {
      const id = action.payload;
      state.layoutId = id;
      state.recent = [id, ...state.recent.filter((x) => x !== id)].slice(0, 6);
    },
    toggleShuffle: (state) => {
      state.shuffle = !state.shuffle;
    },
  },
});

export const { setLayout, toggleShuffle } = keyboardSlice.actions;

export const selectLayoutId = (state) => state.keyboard.layoutId;
export const selectShuffle = (state) => state.keyboard.shuffle;
export const selectRecentLayouts = (state) => state.keyboard.recent;

export default keyboardSlice.reducer;
